module.exports = __webpack_public_path__ + "img/new1-img3.0c1fdd36.png";